module.exports = __webpack_public_path__ + "img/arrow-left.60b7673c.svg";